<template>
  <NuxtLink
    v-if="node.type === 'element' && node.name === 'a' && node.attributes.href?.startsWith('#')"
    v-bind="node.attributes"
    :href="withFragment(route.fullPath, node.attributes.href.substring(1))"
    @click="linkClicked"
  >
    <DynamicNode v-for="(node2, nodeIndex) in node.content" :key="`node-${nodeIndex}`" :node="node2" />
  </NuxtLink>
  <NuxtLink v-else-if="node.type === 'element' && node.name === 'a'" v-bind="node.attributes" @click="linkClicked">
    <DynamicNode v-for="(node2, nodeIndex) in node.content" :key="`node-${nodeIndex}`" :node="node2" />
  </NuxtLink>
  <component :is="node.name" v-else-if="node.type === 'element' && isVoidElement(node.name)" v-bind="node.attributes" />
  <component :is="node.name" v-else-if="node.type === 'element'" v-bind="node.attributes">
    <DynamicNode v-for="(node2, nodeIndex) in node.content" :key="`node-${nodeIndex}`" :node="node2" />
  </component>
  <template v-else-if="node.type === 'text'">{{ node.text }}</template>
  <template v-else>{{ node }}</template>
</template>

<script setup lang="ts">
import { withFragment } from 'ufo'
import type { ContentElement } from './content-element'

const route = useRoute()

const { linkClicked } = inject('dynamic-node', {
  linkClicked() {},
})

defineProps<{ node: ContentElement }>()

const isVoidElement = (element: string) => ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'].includes(element)
</script>

<style lang="scss" scoped>
ul,
:deep(ul) {
  @apply list-disc ps-10;
}
</style>
